import { Global } from './Service/global.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import * as Highcharts from 'highcharts';
import { NavigationEnd, Router } from '@angular/router';
declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private translate:TranslateService, private global:Global,private route : Router){
    translate.setDefaultLang(global.CurentLanguage.value.code);
  }
  isLoading:boolean=false;
  title = 'Site-ANP';
  IsArabe = false;
  ngOnInit(){
    //@ts-ignore
    Date.prototype.addHours = function(h) {
      this.setTime(this.getTime() + (h*60*60*1000));
      return this;
    }
    this.global.isloading.subscribe(load=>{
      load?this.isLoading=load:setTimeout(()=>{this.isLoading=load},500);
    })

    this.global.CurentLanguage.subscribe(lg => {
      if(lg.code=="ar")
      {
        this.IsArabe = true;
        $("html").attr("dir","rtl")
      }
      else{
        this.IsArabe = false;
        $("html").attr("dir","ltr")
      } 
    })
    this.route.events.subscribe(value=>{
      window.scrollTo(0, 0);
      if(value instanceof NavigationEnd){
        this.global.navigationEnd.next();
        $("document").ready(() => {
          //@ts-ignore
          AOS.init();
        })
      }
    })
  }
}
